import api from '../api';

const VIDEO_LIST = api.events.videoList.actionSuccess;

const defaultState = { list: [] };

export default (state = defaultState, action) => {
  switch (action.type) {
    case VIDEO_LIST:
      return { ...state, list: action.data };
    default:
      return state;
  }
};
